"use client";

import MediaImage from "@/components/ui/MediaImage";

import React from "react";
import SectionLayout from "../ui/SectionLayout";
import { SectionProps } from "./model";
import { getDefaultCmsSection } from "@/utils/helper";
import StackedContentComponent from "../ui/StackedContentComponent";
import { getGap } from "@/utils/theme-helper";

const ImageContentSectionComponent: React.FC<
  SectionProps<{
    content: any;
    layoutSizing?: "balanced";
    gap: "xs" | "sm" | "md" | "lg" | "xl";
    image: {
      url: string;
      width: string;
      desktopPosition: "left" | "right";
      mobilePosition: "top" | "bottom";
    };
  }> & {
    recaptchaSiteKey: string;
  }
> = ({ cmsSection, index, cmsData, app, recaptchaSiteKey }) => {
  const balanced = cmsSection.specifics.layoutSizing === "balanced";
  const fraction = (raw: string | undefined) => { const [a, b] = String(raw).split('/').map(Number); return a > 0 && b > a ? a / b : .5; };
  const imageRatio = fraction(cmsSection.specifics.image?.width);
  const imageFirst = cmsSection.specifics.image?.desktopPosition === 'left';
  return (
    <SectionLayout
      cmsSection={getDefaultCmsSection(cmsSection, {
        width: "4xl",
        padding: "none",
      })}
      revealsByElement
    >
      <style>
        {`.section-${index}  {
          --image-height: ${cmsSection.ui.height};
          --image-width: ${(parseFloat(cmsSection.specifics.image?.width.split("/")[0]) / parseFloat(cmsSection.specifics.image?.width.split("/")[1])) * 100}%;
          --content-width: ${(parseFloat(cmsSection.specifics.content?.width.split("/")[0]) / parseFloat(cmsSection.specifics.content?.width.split("/")[1])) * 100}%;
              }`}
      </style>
      {balanced && <style>{`@media(min-width:768px){.section-${index}[data-balanced-layout]{display:grid;grid-template-columns:minmax(0,${imageFirst ? imageRatio : 1-imageRatio}fr) minmax(0,${imageFirst ? 1-imageRatio : imageRatio}fr)}.section-${index}[data-balanced-layout]>div{min-width:0;width:100%}.section-${index}[data-balanced-layout]>div:first-child{order:${imageFirst ? 1 : 0}}.section-${index}[data-balanced-layout]>div:last-child{order:${imageFirst ? 0 : 1}}}`}</style>}
      <div data-balanced-layout={balanced || undefined}
        className={`flex flex-1 h-full section-${index} ${getGap(cmsSection.specifics.gap)}
         ${
           cmsSection.specifics.image?.mobilePosition === "bottom"
             ? "flex-col"
             : "flex-col-reverse"
         }
        ${
          cmsSection.specifics.image?.desktopPosition === "left"
            ? "md:flex-row-reverse"
            : "md:flex-row"
        }`}
      >
        <div className="w-full md:w-[var(--content-width)] homepage-text-lg flex">
          <StackedContentComponent
            cmsData={cmsData}
            config={cmsSection.specifics.content}
            list="content"
            index={index}
            cmsSection={cmsSection}
            app={app}
            recaptchaSiteKey={recaptchaSiteKey}
          />
        </div>
        <div
          className="relative flex h-[var(--image-height)] md:h-full w-full md:w-[var(--image-width)]"
          data-re-reveal={cmsSection.lookAttributes?.motion ? "" : undefined}
        >
          <MediaImage
            alt="Image"
            src={cmsSection.specifics.image?.url}
            className="object-cover h-full w-full"
          />
        </div>
      </div>
    </SectionLayout>
  );
};

export default ImageContentSectionComponent;
